import React from 'react';
import clsx from 'clsx';
import { makeStyles, createStyles, Theme } from '@material-ui/core';
import { dimensions } from '../../../theme';

type Props = {
  style?: React.CSSProperties;
  className?: string;
  children?: React.ReactNode;
  defaultPadding?: number;
  desktopSidePadding?: number;
};

type StyleProps = {
  padding: number;
  desktopSidePadding: number;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paddedContent: (values: StyleProps) => ({
      padding: theme.spacing(values.padding),
      [theme.breakpoints.up('lg')]: {
        paddingLeft: values.desktopSidePadding,
        paddingRight: values.desktopSidePadding,
      },
    }),
  }),
);

const PaddedContent = ({
  children,
  style,
  className,
  defaultPadding = 1,
  desktopSidePadding = dimensions.desktopSidePadding,
}: Props): JSX.Element => {
  const paddingValues: StyleProps = {
    padding: defaultPadding,
    desktopSidePadding,
  };
  const classes = useStyles(paddingValues);
  return (
    <div
      className={clsx(classes.paddedContent, className)}
      style={{ ...style }}
    >
      {children}
    </div>
  );
};

export default PaddedContent;
